<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex';

@Component({
    props: {
        userRole: String,
        teacherName: String,
        dashboardType: String
    },
    computed: {
        ...mapGetters({
            selectedSchool: "admin/getSelectedSchool"
        }),
        displayDashboardTitle(){
            if (this.userRole === 'Teacher') {
                return 'Dashboard'
            } else if (this.userRole !== 'Teacher' && this.dashboardType === 'adminTeacher') {
                return `${this.teacherName}: Dashboard`
            } else {
                return 'School Dashboard'
            }
        },
        assignHediClass(){
            return this.userRole === 'Teacher' && this.dashboardType !== 'adminTeacher' ? 'teacher-hedi' 
                : this.userRole !== 'Teacher' && this.dashboardType === 'adminTeacher' ? 'admin-teacher-hedi' : 'admin-hedi'
        }
    }
})

export default class DashboardHeading extends Vue {
    hediScaleImg = require('../assets/images/hedi-scale.png')
}

</script>

<template>
    <div>
        <h1 class="dashboard-title flex">
            {{displayDashboardTitle}}
            <span v-if="this.userRole !== 'Teacher' && this.dashboardType !== 'adminTeacher'" >
                {{this.selectedSchool.name}}
            </span>
        </h1>

        <div class="hedi flex" :class="assignHediClass">
            <div></div>
            <img :src="hediScaleImg">
        </div>
    </div>
</template>

<style lang="scss" scoped>
    div {
        h1 {
            max-width: 1375px !important;
            font-size: 48px;
            line-height: 1.69;
            letter-spacing: normal;
            color: #613f75;
            text-transform: uppercase;
            margin: 50px auto;
            font-weight: 500;
            &.flex {
                align-items: center;
            }
            span {
                width: 500px;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-left: 25px;
                font-size: 16px;
                color: #4a4a4a;
                line-height: normal;
            }
        }
        .hedi.flex {
            max-width: 1200px;
            div {
                flex-basis: 675px;
            }
        }
        .admin-teacher-hedi,
        .admin-hedi,
        .teacher-hedi {
            text-align: right;
        }
        .teacher-hedi,
        .admin-teacher-hedi {
            margin: -75px auto 20px;
        }
        .admin-hedi {
            margin: -50px auto 50px;
        }
    }
</style>